"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.convertHexToRGB = exports.convertStylesPXtoEM = exports.replacePXinStringWithEM = exports.percToEm = exports.emToPx = exports.pxToRem = exports.pxToEmWithBaseline = exports.pxToEm = void 0;

var _index = require("./index");

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
} // .......... UNIT CONVERSIONS .......... //
// converts pixels in styles to EMs 
// this allows us to create styles as pixels to better match given designs, then convert those to relative units so we can achieve responsive design


var pxToEm = function pxToEm(val) {
  return parseFloat(val) / _index.fontSizeBaseline + "em";
}; // convert values to relative units with the font size baseline


exports.pxToEm = pxToEm;

var pxToEmWithBaseline = function pxToEmWithBaseline(_ref) {
  var value = _ref.value,
      fontSizeBaseline = _ref.fontSizeBaseline;
  return parseFloat(value) / fontSizeBaseline + "em";
}; // create some values as rems so they aren't as affected by font size


exports.pxToEmWithBaseline = pxToEmWithBaseline;

var pxToRem = function pxToRem(val) {
  return parseFloat(val) / _index.fontSizeBaseline + "rem";
}; // convert em to pixel (helpful with perctage conversions)


exports.pxToRem = pxToRem;

var emToPx = function emToPx(val) {
  return parseFloat(val) * _index.fontSizeBaseline + "px";
}; // convert percentages to pixels then to em value (needed for dynamic content sizing based off of content space DOM insertions)


exports.emToPx = emToPx;

var percToEm = function percToEm(parSize, elSize) {
  return pxToEm(parseFloat(emToPx(parSize)) * (parseFloat(elSize) / 100));
}; //log(parSize, elSize);
// convert style string px to em (used by store.js to convert settings file layouts and content styles from pixels to ems)


exports.percToEm = percToEm;

var replacePXinStringWithEM = function replacePXinStringWithEM(passedStyle) {
  // save version of passed style
  var style = passedStyle; // if style contains pixels

  if (style.match(/(\d*(\.\d*)?)px/g)) {
    // store individual px in array
    var pxVals = style.match(/(\d*(\.\d*)?)px/g); // log(style);
    // log(pxVals);
    // convert to ems

    var emVals = pxVals.map(function (px) {
      return pxToEm(px);
    }); // log(emVals);
    // for every pixel we found, replace the px in the original style with the converted em (by matching the index of that array)

    pxVals.forEach(function (val, i) {
      style = style.replace(val, emVals[i]);
    }); // log(style);
  }

  return style;
}; // styles (as object) are passed in here and if any of its rules have px values they will be converted to em


exports.replacePXinStringWithEM = replacePXinStringWithEM;

var convertStylesPXtoEM = function convertStylesPXtoEM(passedStyles) {
  // save version of passed styles
  var styles = Object.assign({}, passedStyles); // get each style

  Object.entries(styles).forEach(function (style) {
    // check if style contains child styles (probably need to make this smarter as this only goes one level deep)
    if (_typeof(style[1]) === "object") {
      Object.entries(style[1]).forEach(function (nestedStyle) {
        // log(nestedStyle[0]);
        styles[style[0]][nestedStyle[0]] = replacePXinStringWithEM(nestedStyle[1]);
      });
    } else {
      styles[style[0]] = replacePXinStringWithEM(style[1]);
    }
  }); // log(styles);

  return styles;
}; // .......... CONVERT HEX TO RGB .......... //
// convert hex to rgb (with opacity param adjuster)


exports.convertStylesPXtoEM = convertStylesPXtoEM;

var convertHexToRGB = function convertHexToRGB(hex, opacity) {
  hex = hex.replace('#', '');
  var r = parseInt(hex.substring(0, 2), 16);
  var g = parseInt(hex.substring(2, 4), 16);
  var b = parseInt(hex.substring(4, 6), 16);
  var result = 'rgba(' + r + ',' + g + ',' + b + ',' + opacity / 100 + ')';
  return result;
};
/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */


exports.convertHexToRGB = convertHexToRGB;